import BusinessSearch from './BusinessSearch';

export default BusinessSearch;
